const TimeSliderProgressMode = {
	STOPPED: 0,
	PLAYING: 1,
	FASTFORWARD: 2
};
export default TimeSliderProgressMode;
